/* global urlPrefix, errorPage */
import Vue from 'vue';
import initApplicationGlobal from './apps/Global/Global';
import initErrorPage from './apps/ErrorPage/ErrorPage';

const _ = require('lodash');

export default function Router() {
  function work() {
    /**
     * т.к. мы работаем с виджетами, которые имеют корневой компонент нам нужно их связать, создаем контейнер евентов,
     * подписка осуществляется в компонентах, в хуке mounted
     * */
    const eventHub = new Vue({
      data() {
        return {
          cities: [],
          mountFunctionBar: false,
        };
      },
      methods: {
        setCities(result) {
          const cities = _.chain(result).sortBy('Name').value();
          this.cities = cities;
        },
      },
    });

    const router = require('routes-js').create(); //eslint-disable-line
    const _urlPrefix = typeof urlPrefix !== 'undefined' ? urlPrefix : ''; //eslint-disable-line

    if (errorPage) {
      initErrorPage();
      return;
    }

    router.route(_urlPrefix ? `${_urlPrefix}` : '/', () => {
      const homePage = Vue.component('homePage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "homePage" */
          './apps/HomePage/HomePage'
        ));
      homePage().then((module) => {
        module.default(eventHub);
      });
    });
    router.route(`${_urlPrefix}/tracking-page`, () => {
      const trackingPage = Vue.component('trackingPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "trackingPage" */
          './apps/TrackingPage/TrackingPage'
        ));
      trackingPage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(`${_urlPrefix}/find_an_office`, () => {
      const findOfficePage = Vue.component('findOfficePage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "findOfficePage" */
          './apps/FindOfiice/FindOffice'
        ));
      findOfficePage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(`${_urlPrefix}/find_an_office/:id`, () => {
      const findOfficePage = Vue.component('findOfficePage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "findOdpPage" */
          './apps/FindOfiice/FindOffice'
        ));
      findOfficePage()
        .then((module) => {
          module.default(eventHub, true);
        });
    });
    router.route(`${_urlPrefix}/our-vacancies`, () => {
      const vacanciesPage = Vue.component('vacanciesPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "vacanciesPage" */
          './apps/VacanciesPage/VacanciesPage'
        ));
      vacanciesPage()
        .then((module) => {
          module.default(eventHub, true);
        });
    });
    router.route(`${_urlPrefix}/biznes-partneram`, () => {
      const businessPartnersPage = Vue.component('businessPartnersPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "businessPartnersPage" */
          './apps/businessPartners/BusinessPartnersPage'
        ));
      businessPartnersPage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(`${_urlPrefix}/ebay`, () => {
      const ebayPage = Vue.component('ebayPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "ebayPage" */
          './apps/Ebay/EbayView'
        ));
      ebayPage()
        .then((module) => {
          module.default(eventHub, true);
        });
    });
    router.route(`${_urlPrefix}/ebay/*`, () => {
      const ebayPage = Vue.component('ebayPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "ebayPageNested" */
          './apps/Ebay/EbayView'
        ));
      ebayPage()
        .then((module) => {
          module.default();
        });
    });
    router.route(`${_urlPrefix}/castnym-klientam`, () => {
      const privateClientsPage = Vue.component('privateClientsPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "privateClientsPage" */
          './apps/CastnymKlientamPage/CastnymKlientamPage'
        ));
      privateClientsPage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(`${_urlPrefix}/castnym-klientam/*`, () => {
      const privateClientsPage = Vue.component('privateClientsPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "privateClientsPageNested" */
          './apps/CastnymKlientamPage/CastnymKlientamPage'
        ));
      privateClientsPage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(`${_urlPrefix}/e-commerce`, () => {
      eventHub.mountFunctionBar = true;

      const ecommercePage = Vue.component('ecommercePage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "ecommercePage" */
          './apps/EcommercePage/EcommercePage'
        ));
      ecommercePage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(`${_urlPrefix}/e-commerce/*`, () => {
      eventHub.mountFunctionBar = true;
      const ecommercePage = Vue.component('ecommercePage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "ecommercePageNested" */
          './apps/EcommercePage/EcommercePage'
        ));
      ecommercePage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(`${_urlPrefix}/e-commerce/dokumenty/dokumenty-i-tarify`, () => {
      const documentPage = Vue.component('documentPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "documentPage" */
          './apps/DocumentPage/DocumentPage'
        ));
      documentPage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(`${_urlPrefix}/o-kompanii/kompania/istoria`, () => {
      const historyPage = Vue.component('historyPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "historyPage" */
          './apps/HistoryCompany/HistoryCompany'
        ));
      historyPage()
        .then((module) => {
          module.default();
        });
    });
    router.route(`${_urlPrefix}/faq/*`, () => {
      const faqPage = Vue.component('faqPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "faqPage" */
          './apps/FaqPage/FaqPage'
        ));
      faqPage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(`${_urlPrefix}/o-kompanii/kontakty/*`, () => {
      const contactsPage = Vue.component('contactsPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "contactsPage" */
          './apps/ContactsPage/ContactsPage'
        ));
      contactsPage()
        .then((module) => {
          module.default();
        });
    });
    router.route(`${_urlPrefix}/search`, () => {
      const searchPage = Vue.component('searchPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "searchPage" */
          './apps/SearchPage/SearchPage'
        ));
      searchPage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(`${_urlPrefix}/international-delivery/ebay_export`, () => {
      const ebayExportPage = Vue.component('ebayExportPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "ebayPage" */
          './apps/EbayExportPage/EbayExportView'
        ));
      ebayExportPage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(`${_urlPrefix}/struct/195`, () => {
      const ebayExportPage = Vue.component('ebayExportPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "ebayPage" */
          './apps/EbayExportPage/EbayExportView'
        ));
      ebayExportPage()
        .then((module) => {
          module.default(eventHub);
        });
    });

    router.route(`${_urlPrefix}/castnym-klientam/mn-dostavka/eksport-ebay-iz-rf`, () => {
      const ebayExportPage = Vue.component('ebayExportPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "ebayPage" */
          './apps/EbayExportPage/EbayExportView'
        ));
      ebayExportPage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(`${_urlPrefix}/struct/201`, () => {
      const requestFormPage = Vue.component('requestFormPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "requestFormPage" */
          './apps/RequestFormPage/RequestFormPage'
        ));
      requestFormPage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(`${_urlPrefix}/franch`, () => {
      const franchPage = Vue.component('franchPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "franchPage" */
          './apps/FranchPage/FranchPage'
        ));
      franchPage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(`${_urlPrefix}/castnym-klientam/dostavka-bagaja`, () => {
      const luggageDeliveryPage = Vue.component('luggageDeliveryPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "luggageDeliveryPage" */
          './apps/LuggageDeliveryPage/LuggageDeliveryPage'
          ));
      luggageDeliveryPage()
        .then((module) => {
          module.default(eventHub);
        });
    });

    let isFallback = true;

    router.route(`${_urlPrefix}/check-url`, () => {
      const PhishingCheckPage = Vue.component('PhishingCheckPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "PhishingCheckPage" */
          './apps/PhishingCheckPage/PhishingCheckPage'
        ));
      PhishingCheckPage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(`${_urlPrefix}/sorry-company`, () => {
      const ApologeticPage = Vue.component('ApologeticPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "ApologeticPage" */
          './apps/ApologeticPage/ApologeticPage'
        ));
      ApologeticPage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(`${_urlPrefix}/e-commerce/uslugi/partner-offer`, () => {
      const PartnerOfferPage = Vue.component('PartnerOfferPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "PartnerOfferPage" */
          './apps/PartnerOfferPage/PartnerOfferPage'
        ));
      PartnerOfferPage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(`${_urlPrefix}/e-commerce/uslugi/partner-offer/*`, () => {
      const PartnerOfferPage = Vue.component('PartnerOfferPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "PartnerOfferPage" */
          './apps/PartnerOfferPage/PartnerOfferPage'
        ));
      PartnerOfferPage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(/\/about_us\/news/, () => {
      const NewsPage = Vue.component('NewsPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "NewsPage" */
          './apps/NewsPage/NewsPage'
        ));
      NewsPage()
        .then((module) => {
          module.default(eventHub);
        });
    });
    router.route(`${_urlPrefix}/biznes-partneram/partner-offer`, () => {
      const partnerIndividualPage = Vue.component('PartnerIndividualPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "PartnerIndividualPage" */
          './apps/PartnerIndividualPage/PartnerIndividualPage'
        ));
      partnerIndividualPage()
        .then((module) => {
          module.default(eventHub);
        });
    });

    router.route(`${_urlPrefix}/biznes-partneram/open-point-pvz`, () => {
      const openPointPVZPage = Vue.component('openPointPVZPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "openPointPVZPage" */
          './apps/openPointPVZPage/openPointPVZPage'
        ));
      openPointPVZPage()
        .then((module) => {
          module.default(eventHub);
        });
    });

    router.route(`${_urlPrefix}/biznes-partneram/open-terminal`, () => {
      const openTerminalPage = Vue.component('OpenTerminalPage',
        () => import(
          /* webpackPrefetch: true */
          /* webpackChunkName: "OpenTerminalPage" */
          './apps/OpenTerminalPage/OpenTerminalPage'
        ));
      openTerminalPage()
        .then((module) => {
          module.default(eventHub);
        });
    });


    router.routes.forEach((route) => {
      if (window.location.pathname.match(route.expr)) {
        isFallback = false;
        route.callback();
      }
    });

    if (isFallback) {
      initApplicationGlobal(eventHub);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', work);
  } else {
    work();
  }
}
